export const rolesPermissionsData = [
  {
    roleName: 'Admin',
    createdOn: '27 Mar 2024',
    key: 1,
  },
  {
    roleName: 'Player',
    createdOn: '20 Mar 2024',
    key: 2,
  },
  {
    roleName: 'Parent',
    createdOn: '16 Mar 2024',
    key: 3,
  },
  {
    roleName: 'Guardian',
    createdOn: '26 Feb 2024',
    key: 4,
  },
  {
    roleName: 'Librarian',
    createdOn: '15 Feb 2024',
    key: 5,
  },
  {
    roleName: 'Accountant',
    createdOn: '13 Feb 2024',
    key: 6,
  },
  {
    roleName: 'Driver',
    createdOn: '28 Jan 2024',
    key: 7,
  },
  {
    roleName: 'Coach',
    createdOn: '21 Jan 2024',
    key: 8,
  },
  {
    roleName: 'Warden',
    createdOn: '10 Jan 2024',
    key: 9,
  },
  {
    roleName: 'Therapist',
    createdOn: '24 Dec 2024',
    key: 10,
  },
];
